import styled from 'styled-components';
import { MIN_TABLET_BREAKPOINT, NAVIGATION_TABLET_MODE, SELECTORS, UBISOFT_BLUE } from '../../constants/constants';

interface IVideoBlockStyle {
  isMobileTitle: boolean;
}

interface IFullScreen {
  fullScreenVideo: boolean;
}

export const VideoBlockContainer = styled.section`
  ${SELECTORS} & {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

//Video section
export const VideoSectionContainer = styled.div`
  ${SELECTORS} & {
      margin: 20px 0 20px auto;
      width: 50%;
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
   ${SELECTORS} & {
     width: 100%;
     margin: 20px auto 20px auto;
   }
  } 
`;

export const VideoImageContainer = styled.div`
  ${SELECTORS} & {
    border-radius: 8px;
    overflow: hidden;
    width: 90%;
    cursor: pointer;
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
   ${SELECTORS} & {
     margin: auto;
     width: 100%;
   }
  } 
  &:hover  {
     box-shadow: 5px 10px ${UBISOFT_BLUE};
  }
`;

export const VideoIframe = styled.iframe`
  ${SELECTORS} & {
    background-color: black;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }
`;

export const VideoClose = styled.div`
    display: ${({ fullScreenVideo }: IFullScreen) => fullScreenVideo ? 'block' : 'none'} !important;
    ${SELECTORS} & {
      z-index: 1002;
      position: fixed;
      left: 100%;
      margin-left: -62px;
      top: 0;
      margin-top: 20px;
      cursor: pointer;
    }
`;

//Video info section
export const VideoInfoContainer = styled.div`
  ${SELECTORS} & {
    margin: auto;
    display: block;
    align-content: flex-end;
    width: 50%;
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
         width: 100%;
         text-align: center;
       }
    }
`;


export const VideoInfoTitle = styled.h1`
  display : ${({ isMobileTitle } : IVideoBlockStyle) => isMobileTitle ? 'none' : 'block'} !important;
  ${SELECTORS} & {
    margin: 0 auto 50px 0;
    font-size: 60px;
    &:after {
      content: none !important;
    }
  }
  
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    display : ${({ isMobileTitle } : IVideoBlockStyle) => isMobileTitle ? 'block' : 'none'} !important;
    ${SELECTORS} & {
       width: 100%;
       text-align: center;
       margin: 0 auto 50px auto;
       font-size: 38px;
     }
  } 
`;

export const VideoInfoDescription = styled.p`
  ${SELECTORS} & {
    font-size: 22px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    span{
      font-size: 22px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
      color: #428ee0;
    }
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
      margin-bottom: 30px;
      margin-top: 15px
  }
`;

export const VideoSubscriptionButtonContainer = styled.div`
    ${SELECTORS} & {
      display: none;
    }
    @media (max-width: ${NAVIGATION_TABLET_MODE}) {
      display: block !important;
    }
    
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
      width: 100%;
    }
`;

export const LineSeparator = styled.div`
    ${SELECTORS} & {
      width: 40%;
      height: 3px;
      border-radius: 50px;
      background-image: linear-gradient(269.47deg, #47E975 3.67%, #0077EE 99.54%); 
      margin: 100px auto;
    }
`;








